export const config = {
  accessToken: __MAPBOX_KEY__,
  maxZoom: 18,
  bearing: 0,
  style: 'mapbox://styles/sofiasamperio/ck44kt2v20klw1cpji5h10lep',
  scrollZoom: false,
  fitBoundsOptions: {
    padding: 100,
  },
};
